enableExperimentalFragmentVariables